const deleteDocument = (db, _id) =>
  db
    .get(`/${_id}`)
    .then(({ data: { _rev } }) =>
      db.delete(`/${_id}?rev=${_rev}`)
    )

export default deleteDocument



// WEBPACK FOOTER //
// ./src/helpers/databases/deleteDocument.js